import {Component, OnInit} from '@angular/core';
import {MxButtonModel} from '../../../../../../../mx-core/src/lib/modules/mx-button/components/mx-button.model';
import {HttpClient} from '@angular/common/http';
import {MessageChainViewModel} from '../../../../models/message.model';
import {MatDialog} from '@angular/material/dialog';
import {PrlNewMessageComponent} from './prl-new-message/prl-new-message.component';
import {Router} from '@angular/router';
import {PrlTranslateService} from '../../../../shared/services/prl-translate.service';
import {PortalMessageService} from '../../services/portal-message.service';
import {PrlLanguageService} from '../../../prl-language/services/prl-language.service';
import {MessageChainPrlObj} from '../../../../../../generated/generated.model';

@Component({
  selector: 'prl-dashboard-messages',
  standalone: false,
  templateUrl: './prl-dashboard-messages.component.html',
  styleUrls: ['./prl-dashboard-messages.component.scss']
})
export class PrlDashboardMessagesComponent implements OnInit{

  selectAll: boolean = false;
  protected deleteButton: MxButtonModel;
  protected readButton: MxButtonModel;
  protected newMessageButton: MxButtonModel;

  pageSizes: number[] = [5, 10, 20, 50, 100];
  messages: MessageChainViewModel[] = [];
  pagination = {
    currentPage: 1,
    pageSize: 5
  };

  constructor (private readonly router: Router,
               private readonly httpClient: HttpClient,
               private readonly dialogRef: MatDialog,
               private readonly translateService: PrlTranslateService,
               private readonly dataService: PortalMessageService,
               private readonly languageService: PrlLanguageService
  ) {}

  ngOnInit(): void {
    this.deleteButton = {
      label: () => this.translateService.getTranslatedLabel('label.dashboard.message.delete'),
      tooltip: () => this.translateService.getTranslatedLabel('label.dashboard.message.delete'),
      disabled: () => !this.isAnyMessageSelected(),
      clickHandler: () => this.onDeleteSelectedMessages()
    };

    this.readButton = {
      label: () => this.translateService.getTranslatedLabel('label.message.read'),
      tooltip: () => this.translateService.getTranslatedLabel('label.message.mark.as.read'),
      disabled: () => !this.hasUnreadSelected(),
      clickHandler: () => this.onMarkSelectedAsRead()
    };

    this.newMessageButton = {
      label: () => this.translateService.getTranslatedLabel('label.dashboard.message.create'),
      tooltip: () => this.translateService.getTranslatedLabel('label.dashboard.message.create'),
      clickHandler: () => this.onCreateNewMessage()
    };

    this.getMessages();
  }

  onDeleteSelectedMessages(): void {
    const selectedIds = this.messages
        .filter(msg => msg.selected)
        .map(msg => msg.subChainId);

    if (selectedIds.length === 0) return;
    const payload = selectedIds;
    this.dataService.markAsDeleted(payload).subscribe({
      next: () => {
        this.messages = this.messages.filter(msg => !selectedIds.includes(msg.subChainId));
      }
    });
  }

  onMarkSelectedAsRead(): void {
    const unreadSelectedIds = this.messages
        .filter(msg => msg.selected && !msg.read)
        .map(msg => msg.subChainId);

    if (unreadSelectedIds.length === 0) return;
    this.dataService.markAsRead(unreadSelectedIds).subscribe({
      next: () => {
        this.messages.forEach(msg => {
          if (unreadSelectedIds.includes(msg.subChainId)) {
            msg.read = true;
          }
        });

        this.selectAll = false;
        this.messages.forEach(msg => msg.selected = false);
      }
    });
  }

  toggleSelectAllMessages(): void {
    this.messages.forEach(msg => msg.selected = this.selectAll);
  }

  onPageSizeChange(): void {
    this.pagination.currentPage = 1;
  }

  getMessages(): void {
    this.dataService.getMessages();
    this.httpClient.get<MessageChainPrlObj[]>('rest/messages')
        .subscribe(response => {
          this.messages = response.map(msg => ({
            ...msg,
            selected: false
          }));
        });
  }

  isAnyMessageSelected(): boolean {
    return this.messages.some(msg => msg.selected);
  }

  hasUnreadSelected(): boolean {
    return this.messages.some(msg => msg.selected && !msg.read);
  }

  onCreateNewMessage(): void {
    const dialogRef = this.dialogRef.open(PrlNewMessageComponent, {
      panelClass: 'mx-dialog-panel-class',
      data: {
        showOld: true
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getMessages();
    });
  }

  onOpenMessage(message: MessageChainViewModel): void {
    const subChainId = message.subChainId;
    this.dataService.markAsRead([subChainId]).subscribe({
      next: () => {
        this.messages.forEach(msg => {
          if (msg.subChainId === subChainId) {
            msg.read = true;
          }
        });
      }
    });
    this.router.navigateByUrl('/messages/' + subChainId);
  }

  getLabel = (label: string): string => {
    return this.languageService.getLabel(label);
  };
}
